import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { ICommandModel } from "app/system/admin-panel/Commands/command-dialog-base/command-dialog-base.component";
import { Observable } from "rxjs";

export class CommandTemplateModel implements ICommandModel {
  Id: number = 0;
  Name: string;
  Command: string = "";
  ObjectIds: number[] = [];

  init(data?: any) {
    if (data) {
      this.Id = data["id"];
      this.Name = data["name"];
      this.Command = data["command"];
      this.ObjectIds = data["objectIds"] ?? [];
    }
  }

  static fromJS(data: any): CommandTemplateModel {
    data = typeof data === 'object' ? data : {};
    let result = new CommandTemplateModel();
    result.init(data);
    return result;
  }

}

export interface ICommandTemplateCreateModel {
  Name: string;
  Command: string;
  ObjectIds: number[];
}

export interface ICommandTemplateUpdateModel {
  Name: string;
  Command: string;
  Id: number;
  ObjectIds: number[];
}


export class RunCommandModel {
  ObjectIds: number[];
  TemplateID: number = 0;
  Command: string = "";
}

@Injectable()
export class CommandsService {
  constructor(private client: HttpClient) {
  }

  public getCommands(): Observable<CommandTemplateModel[]> {
    return this.client.get<any>("/ctrl/CommandTemplates").pipe(map(values => {
      let result = [];
      if (values && values.constructor === Array) {
        for (let item of values)
          result.push(CommandTemplateModel.fromJS(item))
      }

      return result;
    }));
  }

  public runCommand(model: RunCommandModel): Observable<any> {
    return this.client.post<any>("/ctrl/command/run", model);
  }

  public create(model: ICommandTemplateCreateModel) {
    return this.client.post("/ctrl/CommandTemplates", model);
  }

  public update(model: ICommandTemplateUpdateModel) {
    return this.client.put("/ctrl/CommandTemplates", model);
  }

  public delete(id: number) {
    return this.client.delete("/ctrl/CommandTemplates/" + id);
  }
}
